/**
 * Hardcoded home-page update box for the university-of-chicago-settlement docket.
 *
 * Built as DOM nodes (createElement + textContent) rather than an HTML string,
 * so the static copy is not flagged as an HTML-injection sink by code scanning
 * (same rationale as ./rootHub.js). Styled after the CMS Page Alert but bolded
 * (`fw-bold`) with a red (`text-danger`) "JULY 2026 UPDATE:" lead, and inserted
 * *above* the official-settlement banner rather than below it.
 *
 * @module updateBox
 */

/** Bold lead shown before the update body. */
const UPDATE_LEAD = "JULY 2026 UPDATE:";

/** Update body copy (follows the bold lead on the same line). */
const UPDATE_BODY =
    " On July 2, 2026, the Court approved Plaintiffs’ Motion for the First Distribution of the Net Settlement Fund for the first ten settlements with defendants Brown, Chicago, Columbia, Dartmouth, Duke, Emory, Northwestern, Rice, Vanderbilt, and Yale. The administrator has started the distribution processing and claimants can expect to receive their payments within the next 3-4 weeks. Additional updates will be posted on this settlement website as the distributions are issued.";

/**
 * Build the update-box element.
 * @returns {HTMLDivElement} The `div.alert#updateBox` element.
 */
export function buildUpdateBox() {
    const lead = document.createElement("strong");
    lead.className = "text-danger";
    lead.textContent = UPDATE_LEAD;

    const box = document.createElement("div");
    box.className =
        "alert border-dark bg-light text-dark fw-bold mb-3 pt-4 text-center";
    box.id = "updateBox";
    box.append(lead, UPDATE_BODY);
    return box;
}

/**
 * Insert the update box immediately before the given hero element (so it sits
 * above the official-settlement banner). No-op if the hero is absent or the box
 * has already been inserted (guards against re-injection on SPA re-renders).
 *
 * @param {Element|null} hero - The `#official-settlement-website-hero` element.
 * @returns {void}
 */
export function insertUpdateBox(hero) {
    if (!hero || document.getElementById("updateBox")) {
        return;
    }
    hero.before(buildUpdateBox());
}
